import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { trackPhoneClick, trackWhatsAppClick } from '../utils/analytics';

const FixedActions = () => {
  const handleWhatsApp = () => {
    trackWhatsAppClick('fixed_action_button');
    window.open(`https://wa.me/919964660033`, '_blank');
  };

  const handleCall = () => {
    trackPhoneClick('fixed_action_button');
    window.open(`tel:+919964660033`, '_self');
  };

  return (
    <>
      {/* WhatsApp Button - Left */}
      <button 
        className="action-btn whatsapp-btn"
        onClick={handleWhatsApp}
        title="Chat on WhatsApp"
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          transition: 'all 0.2s ease',
          background: '#25D366',
          color: 'white',
          zIndex: 1000
        }}
        onMouseOver={(e) => e.target.style.transform = 'scale(1.1)'}
        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
      >
        <MessageCircle size={24} />
      </button>
      
      {/* Call Button - Right */}
      <button 
        className="action-btn call-btn"
        onClick={handleCall}
        title="Call Us"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          transition: 'all 0.2s ease',
          background: '#FFD700',
          color: '#1A1B1E',
          zIndex: 1000
        }}
        onMouseOver={(e) => e.target.style.transform = 'scale(1.1)'}
        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
      >
        <Phone size={24} />
      </button>
    </>
  );
};

export default FixedActions;